import React from 'react';
import PropTypes from 'prop-types';

import makeClassName from 'shared-utils/src/makeClassName';
import createStyle from 'shared-utils/src/createStyle';
import trackGTMEvents from 'shared-utils/src/trackGTMEvents/new';

import GridItem from '../../../../GridItem';
import Grid from '../../../../Grid';

import style, { mainCls } from './style';

const useStyles = createStyle(style);

const Footer = ({
  device,
  viewportW,
  uri,
  callOpenSpecificModal,
  title,
  priceEl,
  loadDetail,
}) => {
  const cls = useStyles();

  const hdrCls = makeClassName([cls[mainCls], 'c-bg--w', 'bb--s', 'is-rel']);


  const leadBtnCls = makeClassName([
    cls[`${mainCls}__leadbtn`],
    'c-bg--primary',
    'c-txt--w',
    'tp-w--l',
    'tp-s--l',
    'b-r--m',
    'is-clickable',
    'pt--ms pl--m pb--ms pr--ms',
  ]);

  const goToPDP = (ev) => {
    trackGTMEvents({
      category: 'Interaction',
      action: 'GoToPDP',
      position: 'PGP_Footer',
    }, {}, true);
    loadDetail(ev, uri, false, false, null);
  };

  const clsDtlsBtn = makeClassName([
    cls[`${mainCls}__btn-detail`],
    'tp-w--m',
    'tp-s--l',
    'c-bg--w',
    'c-txt--f0',
    'pt--ms pl--m pb--ms pr--ms',
    'is-clickable',
    'mr--s',
  ]);
  return (
    <GridItem className={hdrCls} behavior="fixed">
      <Grid
        className={cls[`${mainCls}__h100`]}
        align={device !== 'smartphone' ? 'center' : null}
      >
        {device === 'desktop' || viewportW >= 1024? (
          <GridItem
            className={`${
              cls[`${mainCls}__title`]
            }${' tp-a--r tp-s--l tp-w--l'}`}
            behavior="fixed"
          >
            {title.main} • {priceEl}
          </GridItem>
        ) : (
          <Grid className={`${cls[`${mainCls}__utils`]} p--ms`} direction="column">
            <button
              type="button"
              onClick={(ev) => goToPDP(ev)}
              className={clsDtlsBtn}
              bg="w"
              border="b-r--m"
            >
              Dettagli immobile
            </button>
            <button 
              type="button"
              className={leadBtnCls}
              onClick={() => callOpenSpecificModal({ forcedPosition: 'PGP_Footer'})}
            >
              Contatta
            </button>
          </Grid>
        )}
      </Grid>
    </GridItem>
  );
};

export default Footer;
